import { render } from "./Perfil.vue?vue&type=template&id=6365d7ca"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=6365d7ca&lang=css"
script.render = render

export default script